import JobsFilters from "./jobs-filters";
import Bookmarks from "./bookmarks";

const jobsFilters = new JobsFilters();
new Bookmarks(jobsFilters);

window.dispatchEvent(
    new Event('jobs-loaded')
);
